/* global $:false */
;(function () {
  'use strict'

  angular.module('admin.challenges.edit', []).controller('ChallengesEditCtrl', ChallengesEditCtrl)

  /** @ngInject */
  function ChallengesEditCtrl(
    $scope,
    $state,
    $stateParams,
    $timeout,
    ChallengesService,
    CacheService,
    UploadService,
    ShelfieElementsService,
  ) {
    var vm = this
    vm.model = {
      img: '',
      rule: [],
    }
    vm.elements = []
    vm.pathImg = ''
    vm.params = $stateParams.id
    vm.isOpen = false
    vm.isOpen2 = false
    vm.ruleTypes = [
      {
        id: 0,
        name: 'Background',
      },
      {
        id: 1,
        name: 'Accessory',
      },
      {
        id: 2,
        name: 'Overlay',
      },
      {
        id: 10,
        name: 'Custom Background',
      },
      // {
      //   id: 3,
      //   name: 'Collectible',
      // },
    ]

    function convertJsonToString(str) {
      try {
        return JSON.stringify(str)
      } catch (e) {
        return ''
      }
    }

    function loadElements() {
      ShelfieElementsService.listElements().then(function (result) {
        var elements = JSON.parse(result.Body.toString())
        var shelves = elements.results ? elements.results.backgrounds : []
        var accessories = elements.results ? elements.results.accessories : []
        var overlays = elements.results ? elements.results.overlays : []

        var shelvesNoDuplicate = []
        for (var i = 0; i < shelves.length; i++) {
          if (shelves[i].name) {
            shelvesNoDuplicate.push(shelves[i])
          }
        }

        var accessoriesNoDuplicate = []
        for (var i = 0; i < accessories.length; i++) {
          if (accessories[i].name) {
            accessoriesNoDuplicate.push(accessories[i])
          }
        }

        var overlaysNoDuplicate = []
        for (var i = 0; i < overlays.length; i++) {
          if (overlays[i].name) {
            overlaysNoDuplicate.push(overlays[i])
          }
        }

        var ele = {
          results: {
            accessories: accessoriesNoDuplicate,
            backgrounds: shelvesNoDuplicate,
            overlays: overlaysNoDuplicate,
          },
        }
        vm.elements = ele.results
      })
    }

    loadElements()

    vm.openCalendar = function (e) {
      e.preventDefault()
      e.stopPropagation()

      vm.isOpen = true
    }

    vm.openCalendar2 = function (e) {
      e.preventDefault()
      e.stopPropagation()

      vm.isOpen2 = true
    }

    if (vm.params !== '0') {
      vm.id = $stateParams.id
      ChallengesService.get($stateParams.id).then(function (result) {
        vm.model = result.results
        if (
          vm.model['ts-start'] !== undefined &&
          vm.model['ts-start'] !== null &&
          vm.model['ts-start'] !== 0
        ) {
          vm.model['ts-start'] = vm.model['ts-start']
            .toString()
            .substring(0, vm.model['ts-start'].toString().length - 3)
          vm.model['ts-start'] = new Date(parseInt(vm.model['ts-start']))
          vm.dataStart = angular.copy(vm.model['ts-start'])
        }

        if (
          vm.model['ts-end'] !== undefined &&
          vm.model['ts-end'] !== null &&
          vm.model['ts-end'] !== 0
        ) {
          vm.model['ts-end'] = vm.model['ts-end']
            .toString()
            .substring(0, vm.model['ts-end'].toString().length - 3)
          vm.model['ts-end'] = new Date(parseInt(vm.model['ts-end']))
          vm.dataEnd = angular.copy(vm.model['ts-end'])
        }

        if (vm.model.rule === '' || vm.model.rule === undefined || vm.model.rule === null) {
          vm.model.rule = []
        }
      })
    }

    var isDate = function (date) {
      return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
    }

    vm.save = function () {
      var model = angular.copy(vm.model)
      delete model.ts
      delete model['ts-m']
      var msg = ''

      if (!model.t) {
        swal('Title field is required.', '', 'error')
        return
      }

      if (!model.txt) {
        swal('Description field is required.', '', 'error')
        return
      }

      if (!model.img) {
        swal('Image field is required.', '', 'error')
        return
      }

      if (!model['txt-p']) {
        swal('PrizeText field is required.', '', 'error')
        return
      }

      if (!model['color-b-start']) {
        swal('BannerStartColor field is required.', '', 'error')
        return
      }

      if (!model['color-b-end']) {
        swal('BannerEndColor field is required.', '', 'error')
        return
      }

      if (!model['color-p-start']) {
        swal('PrizeStartColor field is required.', '', 'error')
        return
      }

      if (!model['color-p-end']) {
        swal('PrizeEndColor field is required.', '', 'error')
        return
      }

      if (!model['color-txt-p']) {
        swal('PrizeTextColor field is required.', '', 'error')
        return
      }

      if (!model['color-txt-t']) {
        swal('TimeTextColor field is required.', '', 'error')
        return
      }

      if (!model.h) {
        swal('Hashtag field is required.', '', 'error')
        return
      } else {
        if (model.h.indexOf('QC-') === -1) {
          model.h = 'QC-' + model.h
        }
      }

      if (model.t.length > 26) {
        swal('Title field limit 26 characters', '', 'warning')
        return
      }

      if (model.txt.length > 250) {
        swal('Description field limit 250 characters', '', 'warning')
        return
      }

      if (model.h.length > 44) {
        swal('Hashtag field limit 44 characters', '', 'warning')
        return
      }

      if (model['txt-p'].length > 16) {
        swal('Prize Text field limit 16 characters', '', 'error')
        return
      }

      if (!model.rule) {
        swal('Rule field is required.', '', 'error')
        return
      }

      if (!model['c-pr-min']) {
        if (!model['c-win']) {
          swal('Add Number of Winners OR Min Praises', '', 'error')
          return
        }
      }

      if (!model['c-win']) {
        if (!model['c-pr-min']) {
          swal('Add Number of Winners OR Min Praises', '', 'error')
          return
        }
      }

      if (model['c-win'] && model['c-pr-min']) {
        swal('Add Number of Winners OR Min Praises', '', 'error')
        return
      }

      if (vm.dataStart !== undefined && vm.dataStart !== '' && vm.dataStart !== null) {
        if (isDate(vm.dataStart)) {
          var date = parseInt(new Date(new Date(vm.dataStart).setSeconds(0)).getTime() * 1000)
          model['ts-start'] = date
        } else {
          swal('Date field invalid.', '', 'error')
          return
        }
      } else {
        swal('Cannot save. Add Started At date to save', '', 'error')
        return
      }

      if (vm.dataEnd !== undefined && vm.dataEnd !== '' && vm.dataEnd !== null) {
        if (isDate(vm.dataEnd)) {
          var date = parseInt(new Date(new Date(vm.dataEnd).setSeconds(0)).getTime() * 1000)
          model['ts-end'] = date
        } else {
          swal('Date field invalid.', '', 'error')
          return
        }
      } else {
        swal('Cannot save. Add Ended At date to save', '', 'error')
        return
      }

      if (model.c === 0 || model.c === null || model.c === undefined || model.c === '') {
        delete model.c
      } else {
        model.c = parseInt(model.c)
      }

      model.rv = 1
      var rule = convertJsonToString(model.rule)
      if (rule === '') {
        swal('The rules is invalid.', '', 'error')
        return
      } else {
        if (model.rule.length === 0) {
          swal('The rules is invalid.', '', 'error')
          return
        }
        model.rule = rule
      }

      if (model.id !== undefined && model.id !== '' && model.id !== 0) {
        ChallengesService.update(model.id, model).then(
          function () {
            $state.go('admin.challenges')
          },
          function (err) {
            swal(err.error.message, '', 'error')
          },
        )
      } else {
        ChallengesService.save(model).then(
          function () {
            $state.go('admin.challenges')
          },
          function (err) {
            swal(err.error.message, '', 'error')
          },
        )
      }
    }

    vm.cancel = function () {
      swal(
        {
          title: 'Cancel Challenge',
          text: 'You really want to cancel ?',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            $state.go('admin.challenges')
          } else {
            return
          }
        },
      )
    }

    vm.upload = function (item) {
      vm.load = true
      var id = 0
      if (item.id) {
        id = item.id
      }
      UploadService.save('challenges', vm.pathImg, 'img', id).then(function (fileName) {
        vm.load = false
        item.img = fileName
      })
    }

    vm.addRule = function () {
      if (!vm.model.rule) {
        vm.model.rule = []
      }
      vm.rule = {
        t: '',
        k: null,
        url: '',
        'c-min': 1,
        edit: false,
      }

      vm.shelfie = null
      vm.element = []
      $('#modalShelfies').modal('show')
    }

    vm.editRule = function (item) {
      vm.rule = {
        t: item.t,
        k: item.k,
        url: item.url,
        'c-min': 1,
      }
      vm.chooseType(item.k)
      vm.shelfie = item.t
      vm.chooseShelfie(vm.shelfie)

      $('#modalShelfies').modal('show')
    }

    vm.cancelRule = function (item) {
      swal(
        {
          title: 'Are you sure?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            vm.shelfie = null
            vm.element = []
            vm.rule = {}
            $('#modalShelfies').modal('hide')
            $scope.$apply()
          }
        },
      )
    }

    vm.deleteRule = function (item) {
      swal(
        {
          title: 'Are you sure?',
          text: '',
          type: 'warning',
          showCancelButton: true,
          closeOnConfirm: true,
          closeOnCancel: true,
          animation: 'slide-from-top',
        },
        function (isConfirm) {
          if (isConfirm) {
            var rules = angular.copy(vm.model.rule)
            for (var i = 0; i < rules.length; i++) {
              if (rules[i].t === item.t) {
                rules.remove(rules[i])
                break
              }
            }
            vm.model.rule = rules
            $scope.$apply()
          }
        },
      )
    }

    vm.saveRule = function () {
      if (!vm.rule.t) {
        swal('Required Title field.', '', 'error')
        return
      }

      if (!vm.rule.url && vm.rule.k !== 10) {
        swal('Required Url field.', '', 'error')
        return
      }

      if (vm.rule.k === undefined || vm.rule.k === null || vm.rule.k === '') {
        swal('Required Type field.', '', 'error')
        return
      }

      if (vm.rule.k === 0) {
        for (var i = 0; i < vm.model.rule.length; i++) {
          if (vm.model.rule[i].k === vm.rule.k) {
            swal('Background already exists in rule.', '', 'error')
            return
          }
        }
      }

      if (vm.rule.k === 2) {
        for (var i = 0; i < vm.model.rule.length; i++) {
          if (vm.model.rule[i].k === vm.rule.k) {
            swal('Overlay already exists in rule.', '', 'error')
            return
          }
        }
      }

      if (vm.rule.k === 10) {
        for (var i = 0; i < vm.model.rule.length; i++) {
          if (vm.model.rule[i].k === 0 && vm.model.rule[i].url === 'custom_background') {
            swal('Custom Background already exists in rule.', '', 'error')
            return
          }
          if (vm.model.rule[i].k === 0) {
            swal('Background already exists in rule.', '', 'error')
            return
          }
        }
      }

      if (vm.rule.k !== 10) {
        for (var i = 0; i < vm.model.rule.length; i++) {
          if (vm.model.rule[i].t === vm.rule.t && vm.model.rule[i].k === vm.rule.k) {
            swal('This rule already exists.', '', 'error')
            return
          }
        }
      } else {
        vm.rule.k = 0
      }

      vm.model.rule.push(vm.rule)
      $('#modalShelfies').modal('hide')
    }

    vm.chooseType = function (type) {
      vm.shelfie = null
      vm.rule.t = ''
      vm.rule.url = ''
      switch (type) {
        case 0:
          vm.element = vm.elements.backgrounds
          break
        case 1:
          vm.element = vm.elements.accessories
          break
        case 2:
          vm.element = vm.elements.overlays
          break
        case 10:
          vm.rule.t = 'custom_background'
          vm.rule.url = 'custom_background'
          break
      }
    }

    vm.chooseShelfie = function () {
      var selected = _.find(vm.element, { name: vm.shelfie })
      vm.rule.t = selected.name
      vm.rule.url = selected['img-l']
    }
  }
})()
